import NewOpportunityHeader from "./components/NewOpportunityHeader";

export default NewOpportunityHeader;